import { createSlice } from "@reduxjs/toolkit";
import { getAllEventsThunk } from "./thunk";


export const initialState = {
    data: [],
    error: {},
    isLoading:false,
};

const EventSlice = createSlice({
    name: 'EventSlice',
    initialState,
    reducer: {},
    extraReducers: (builder) => {

          //get all events
        builder.addCase(getAllEventsThunk.pending, (state, action) => {
             state.isLoading = true;
        });

          builder.addCase(getAllEventsThunk.fulfilled, (state, action) => { 
                state.data = action.payload.data;
                state.isLoading = false
        });

        builder.addCase(getAllEventsThunk.rejected, (state, action) => {
            state.error = action.payload.success || null;
            state.isLoading = false;
        });
             
    }
});

export default EventSlice.reducer;